import $ from 'jquery';

class HeaderScroll  {

	constructor(args) {

		this.vw = $(window).width();
		this.isOpen = false;
		this.headerThreshold = args.threshold;
		this.header = args.header;
		this.class = args.class;

		this.init();

	}

	init() {

		if (this.vw >= 768) {
			this.handleScroll();
			this.doScroll();
			setTimeout(() => {
				this.detectScroll();
			}, 400);	
		}
		else {
			this.header.addClass('open');
		}



	}

	doScroll() {

		$(window).on('scroll', () => {
			this.handleScroll();
		});

	}

	detectScroll() {
		var lastScrollTop = 0;
		var self = this;
		console.log('detectScroll');
		$(window).scroll(function(event){
			var scrollToTop = $(this).scrollTop();
			if( scrollToTop > 20 && !self.getIsScrolling) {
				if (scrollToTop > lastScrollTop){
					self.header.addClass('scrolled');
					if( self.header.hasClass('sticky-anchors') ) {
						self.header.removeClass('sticky-anchors');
					}

				} else {

					self.header.removeClass('scrolled');

				}
				lastScrollTop = scrollToTop;
			}	
		});

	}

	handleScroll() {

		this.scrollTop = $(window).scrollTop();

		if( this.scrollTop > this.headerThreshold  ) {
			if( !this.isOpen ) {
				this.isOpen = true;
				this.header.addClass( this.class );
			}
		}
		else {
			if( this.isOpen ) {
				this.isOpen = false;
				this.header.removeClass( this.class );
			}
		}

	}

}



module.exports = HeaderScroll;